import React, { Component } from 'react'
import classNames from 'classnames'
import { withTranslation } from 'react-i18next'
import { IToggleBoxProps } from './interface';



class ToggleBox extends Component<IToggleBoxProps> {
  state = {
    expanded: false,
  }
  render() {
    const { expanded } = this.state
    const { t, children, contentLabel, onOpen, custom } = this.props
    return (
      <div className="toggle-box">
        <div
          className={classNames('toggle-box__wrapper', {
            'toggle-box__wrapper--no-margin': custom,
          })}
        >
          <div className="toggle-box__top">
            <div
              className={classNames({
                'toggle-box__toggler': true,
                'toggle-box__toggler--expanded': expanded,
              })}
              onClick={() => {
                !expanded && onOpen && onOpen()
                this.setState({ expanded: !expanded })
              }}
            >
              {t(`${expanded ? 'Hide' : 'View'} ${contentLabel}`)}
              <div className="toggle-box__arrow" />
            </div>
          </div>
          <div
            className={classNames('toggle-box__content', {
              'toggle-box__content--no-border': custom,
            })}
          >
            {expanded && children}
          </div>
        </div>
      </div>
    )
  }
}

export default withTranslation('user')(ToggleBox)
